import React from "react";
import { Container } from "./styles";
import logo from "../../../assets/images/logoname.webp";

const Logo = () => {
  return (
    <Container href="/">
      <img src={logo} alt="logo" height="80" />
      {/* <p className="dc-title">Grokcoin</p> */}
    </Container>
  );
};

export default Logo;
